import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";

import arrowIconWhite from "../../../assets/images/Vector_btn.png";

import ImgDiv from "../../../assets/images/sezione-05-popup-03-03-img-01.svg";

export default function AnalisiApprofondimento({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Comunità interessate", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[2000] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Perimetro di consolidamento"
    >
      <div
        className="
          relative w-full md:w-[1280px] bg-white shadow-2xl
          max-h-[90vh] overflow-y-auto overscroll-contain
        "
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
      >
        {/* Azioni in alto */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("AnalisiApprofondimento")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="px-5 md:px-8 pb-6 -mt-6">

            <h2 className="text-[#3D8E2F] text-[30px] md:text-[40px] font-normal">
                Comunità Interessate
            </h2>

            <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em] font-bold">
              The mutualistic nature of Reale Group is a distinctive element that permeates activities and relationships even in the territory.
            </p>
              
            <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em]">
              This approach translates into <b>constant listening and involvement of the communities</b> in which the Group is present and operates in order to promote sustainable development.
            </p>
              
            <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em]">
              Since 2017, <b>Reale Foundation</b>, the Corporate Foundation of Reale Group, has been active in Italy, Spain, Chile, and Greece, and through its initiatives pursues general interest purposes in the cultural, sports, environmental protection, civic, assistance, and social inclusion fields. Reale Foundation is committed to <b>pursuing the sustainable development goals defined by the UN 2030 Agenda</b>, implements programs aimed at preventing the onset of chronic diseases by promoting the prevention of risk factors (SDG no. 3), and promotes the inclusion and socio-economic development of young people in vulnerable conditions (SDGs no. 1 and 8).
            </p>
              
            

            <div className="flex flex-col md:flex-row gap-8 mt-8">
                
                <div className="flex w-full md:w-1/3">
                    <img src={ImgDiv} className="w-full" alt=""></img>
                </div>

                <div className="flex w-full md:w-2/3">
                    <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em]">
                      Furthermore, it increasingly intervenes to <b>support communities affected by natural disasters</b>, activating its <b>"Emergency Protocol"</b> and planning initiatives aimed at increasing the ability to prevent and cope with the consequences of climate change. Strategic alliances with Local Authorities, Health and Emergency Structures allow Reale Foundation and Reale Group to contribute to <b>Goal 17 "Partnerships for the Goals" for the UN 2030 Agenda.</b>
                    </p>
                </div>
            </div>
            
            <a href="https://realefoundation.org/" target="_blank" rel="noopener">
              <button
                className="bt-secondary text-[16px] md:text-[22px] mt-12 border-[1px] border-[#0E3761]"
              >
                <img
                  src={arrowIconWhite}
                  alt="Arrow"
                  className="inline-block mr-2 w-[20px] h-[20px]"
                />
                Visita realefoundation.org
              </button>
            </a>

        </div>

        </div>
    </div>,
    document.body
  );
}
